import { render, staticRenderFns } from "./UiFilterCategories.vue?vue&type=template&id=a1d15012&"
import script from "./UiFilterCategories.vue?vue&type=script&lang=js&"
export * from "./UiFilterCategories.vue?vue&type=script&lang=js&"
import style0 from "./UiFilterCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports